import { FEATURE_PDP_LABOR_DAY_SALE } from 'constants/features';
import { cn } from 'helpers/classnames';
import { useIsEnrolledInVariant } from 'hooks/unleash/useIsEnrolledInVariant';
import useMartyContext from 'hooks/useMartyContext';

interface LaborDayPromoProps {
  className?: string;
}

export const LaborDayPromo = ({ className }: LaborDayPromoProps) => {
  const { isEnrolled: isLaborDaySaleEnabled } = useIsEnrolledInVariant(FEATURE_PDP_LABOR_DAY_SALE);
  const {
    marketplace: { is6pm }
  } = useMartyContext();

  if (!isLaborDaySaleEnabled || is6pm) {
    return null;
  }

  return (
    <p data-test-id="laborDaySale" className={cn('w-fit rounded-sm bg-green-50 p-1 text-sm text-gray-800', className)} role="alert">
      Use code <span className="font-bold">SAVE20 at</span> checkout
    </p>
  );
};
